import { PageBuilderModuleItemDataProps } from "apis/page-builder";

export type ModuleSettingConfigItemTabType = "param" | "style" | "text" | "color" | "size";
export interface ModuleSettingConfigItemProps {
    pKey: string;
    alilas?: string;
    tab?: ModuleSettingConfigItemTabType;
    hidden?: boolean;
}
export interface ModuleSettingsProps {
    dataSetup?: boolean;
    configs: ModuleSettingConfigItemProps[];
}
export interface ModuleItemProps {
    id: number;
    code: string;
    name: string;
    thumbnailUrl?: string;
    content: string;
    script?: string;
    configStructure?: string;
    sort: number;
    publish?: boolean;
    description?: string;
    configJSON?: string;
    groupName?: string;
    data?: PageBuilderModuleItemDataProps;
    settings?: ModuleSettingsProps;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

export * from "./fetch";
export * from "./find";
export * from "./create";
export * from "./update";
export * from "./remove";
export * from "./groups"

type ModuleGroup = {
    groupName: string;
    modules: ModuleItemProps[];
};

export function groupModules(modules: ModuleItemProps[]): ModuleGroup[] {
    const map = modules.reduce<Record<string, ModuleItemProps[]>>((acc, item) => {
        const key = item.groupName || "Other";

        if (!acc[key]) {
            acc[key] = [];
        }

        acc[key].push(item);
        return acc;
    }, {});

    return Object.entries(map)
        .sort(([a], [b]) => {
            if (a === "Other") return 1;
            if (b === "Other") return -1;
            return a.localeCompare(b);
        })
        .map(([groupName, modules]) => ({
            groupName,
            modules
        }));
}